window.EmzQuizConfig = {
  products: [

    // ===== FACE PRODUCTS (27 items) =====
    {
      handle: 'age-well-facial-cleansing-bar',
      reason: 'This rose clay bar gently removes impurities while respecting mature, dry skin.',
      skinTypes: ["mature", "dry", "sensitive"],
      concerns: ["aging", "dryness", "none"],
      scents: ["floral", "herbal"],
      categories: ["face"],
      boost: 1
    },

    {
      handle: 'age-well-serum-anti-aging-facial-serum',
      reason: 'Premium rosehip, sea buckthorn, and vitamin E work together to visibly reduce fine lines.',
      skinTypes: ["dry", "sensitive", "mature"],
      concerns: ["aging", "dryness"],
      scents: ["floral", "herbal"],
      categories: ["face"],
      boost: 2
    },

    {
      handle: 'age-well-facial-sugar-polish-mask',
      reason: 'This 2-in-1 exfoliant and mask brightens aging skin while maintaining moisture.',
      skinTypes: ["dry", "sensitive", "mature"],
      concerns: ["aging", "dryness"],
      scents: ["floral", "herbal"],
      categories: ["face"],
      boost: 1
    },

    {
      handle: 'vital-wize-brightening-facial-serum',
      reason: 'Illuminate your complexion with this powerful brightening serum.',
      skinTypes: ["dry", "sensitive", "normal", "combination"],
      concerns: ["aging", "dryness", "none"],
      scents: ["citrus", "floral"],
      categories: ["face"],
      boost: 1
    },

    {
      handle: 'vital-wize-facial-polish-mask',
      reason: 'Vitamin C and AHA fruit enzymes gently polish away dullness for glowing skin.',
      skinTypes: ["dry", "sensitive", "normal", "combination"],
      concerns: ["aging", "dryness", "none"],
      scents: ["citrus", "floral"],
      categories: ["face"],
      boost: 1
    },

    {
      handle: 'detox-facial-polish-mask',
      reason: 'Deep cleanse and exfoliate breakout-prone skin with this powerful detox treatment.',
      skinTypes: ["oily", "combination"],
      concerns: ["breakouts", "none"],
      scents: ["herbal"],
      categories: ["face"],
      boost: 2
    },

    {
      handle: 'coconut-cream-vanilla-bean-facial-sugar-polish-mask',
      reason: 'This creamy exfoliant soothes eczema while gently buffing away dead skin.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "dryness", "redness"],
      scents: ["sweet"],
      categories: ["face"],
      boost: 1
    },

    {
      handle: 'advanced-anti-blemish-serum',
      reason: 'Tea tree, willow bark, and niacinamide target blemishes at the source.',
      skinTypes: ["oily", "combination", "normal"],
      concerns: ["breakouts", "none"],
      scents: ["herbal"],
      categories: ["face"],
      boost: 2
    },

    {
      handle: 'repair-care-regenerating-facial-serum',
      reason: 'Help heal acne damage and restore skin clarity with this regenerating serum.',
      skinTypes: ["oily", "combination", "normal"],
      concerns: ["breakouts", "none"],
      scents: ["herbal"],
      categories: ["face"],
      boost: 1
    },

    {
      handle: 'chamomile-rose-facial-cream',
      reason: 'Calm reactive skin with this anti-inflammatory cream that feels like a soothing embrace.',
      skinTypes: ["sensitive", "combination"],
      concerns: ["redness", "eczema", "none"],
      scents: ["floral", "herbal"],
      categories: ["face"],
      boost: 1
    },

    {
      handle: 'balancing-blend-light-facial-lotion',
      reason: 'A lightweight moisturizer that hydrates without excess oil for combination and acne-prone skin.',
      skinTypes: ["combination", "oily", "normal"],
      concerns: ["breakouts", "none"],
      scents: ["herbal"],
      categories: ["face"],
      boost: 0
    },

    {
      handle: 'whipped-chamomile-mint-facial-cleanser',
      reason: 'This gentle whipped cleanser removes impurities while protecting sensitive and eczema-prone skin.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "redness", "dryness"],
      scents: ["herbal"],
      categories: ["face"],
      boost: 1
    },

    {
      handle: 'face-food-original-cucumber-carrot',
      reason: 'A rich, nutrient-dense moisturizer that feeds dry and sensitive skin what it craves.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "dryness", "redness"],
      scents: ["herbal", "fresh", "light"],
      categories: ["face"],
      boost: 1
    },

    {
      handle: 'face-food-coconut-milk-vanilla-bakuchiol',
      reason: 'Get the anti-aging benefits of retinol without the irritation using nature\'s bakuchiol.',
      skinTypes: ["dry", "sensitive", "mature"],
      concerns: ["aging", "dryness"],
      scents: ["light", "sweet"],
      categories: ["face"],
      boost: 1
    },

    {
      handle: 'organic-facial-soap',
      reason: 'Lavender and rose geranium combine in this classic bar that cleanses without stripping.',
      skinTypes: ["normal", "sensitive", "dry"],
      concerns: ["none", "redness", "dryness"],
      scents: ["floral", "herbal"],
      categories: ["face"],
      boost: 1
    },

    {
      handle: 'bamboo-charcoal-tea-tree-facial-soap',
      reason: 'Detoxify and clear breakouts with activated charcoal and purifying tea tree.',
      skinTypes: ["oily", "combination"],
      concerns: ["breakouts", "none"],
      scents: ["herbal", "earthy"],
      categories: ["face"],
      boost: 1
    },

    {
      handle: 'hydrating-facial-mist-cucumber-rose-hyaluronic-acid',
      reason: 'Refresh and hydrate your skin anytime with this lightweight hyaluronic mist.',
      skinTypes: ["dry", "sensitive", "normal", "combination", "oily"],
      concerns: ["dryness", "redness", "none"],
      scents: ["floral", "fresh", "light"],
      categories: ["face"],
      boost: 1
    },

    {
      handle: 'all-natural-lash-shampoo',
      reason: 'Keep your lashes clean and healthy with this gentle, natural cleanser.',
      skinTypes: ["sensitive", "normal", "dry"],
      concerns: ["none", "redness"],
      scents: ["unscented"],
      categories: ["face"],
      boost: 0
    },

    {
      handle: 'brow-balm-growth-microblading-aftercare',
      reason: 'Nourish brow growth and support microblading recovery with this caring balm.',
      skinTypes: ["sensitive", "normal", "dry"],
      concerns: ["none", "redness"],
      scents: ["herbal"],
      categories: ["face"],
      boost: 0
    },

    {
      handle: 'age-well-facial-kit',
      reason: 'Complete Age Well 3-step facial system—a full routine targeting aging concerns beautifully.',
      skinTypes: ["dry", "combination"],
      concerns: ["aging"],
      scents: ["floral", "herbal"],
      categories: ["gift", "face"],
      boost: 2
    },

    {
      handle: 'age-well-facial-try-it-kit',
      reason: 'Perfect introduction to Age Well—sample sizes to discover your new skincare routine.',
      skinTypes: ["dry", "combination", "sensitive"],
      concerns: ["aging"],
      scents: ["floral", "herbal"],
      categories: ["gift", "face"],
      boost: 1
    },

    {
      handle: 'nourishing-facial-skin-care-kit',
      reason: 'Nourishing facial kit—a loving gift for anyone with dry or sensitive skin.',
      skinTypes: ["dry", "sensitive"],
      concerns: ["aging", "dryness"],
      scents: ["floral", "herbal", "fresh", "light"],
      categories: ["gift", "face"],
      boost: 1
    },

    {
      handle: 'clarifying-regimen-complete-facial-skin-care-kit',
      reason: 'Clarifying kit tackles breakouts with a complete multi-step routine.',
      skinTypes: ["oily", "combination"],
      concerns: ["breakouts"],
      scents: ["floral", "herbal", "fresh", "light"],
      categories: ["gift", "face"],
      boost: 1
    },

    {
      handle: 'detox-facial-blemish-repair-care-kit',
      reason: 'Complete detox and repair system—help breakout-prone skin heal and thrive.',
      skinTypes: ["oily", "combination"],
      concerns: ["breakouts"],
      scents: ["floral", "herbal", "fresh", "light"],
      categories: ["gift", "face"],
      boost: 1
    },

    {
      handle: 'detox-facial-try-it-kit',
      reason: 'Try the Detox system before committing—perfect for acne-prone skin curiosity.',
      skinTypes: ["oily", "combination"],
      concerns: ["breakouts"],
      scents: ["floral", "herbal", "fresh", "light"],
      categories: ["gift", "face"],
      boost: 0
    },

    {
      handle: 'healthy-facial-kit-boxed-set',
      reason: 'Healthy facial kit in a beautiful box—a gift for glowing skin.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["dryness", "redness"],
      scents: ["floral", "herbal", "fresh", "light"],
      categories: ["gift", "face"],
      boost: 0
    },

    {
      handle: 'zinc-oxide-daily-mineral-moisturizer',
      reason: 'Daily mineral moisturizer with zinc oxide—lightweight protection for face and body.',
      skinTypes: ["sensitive", "oily", "combination", "normal"],
      concerns: ["breakouts", "redness", "none"],
      scents: ["fresh", "light", "herbal"],
      categories: ["face", "lotion"],
      boost: 1
    },

    // ===== SOAP BARS (31 items) =====

    {
      handle: 'lavender-soap-bar',
      reason: 'Our best-selling lavender bar is pure French lavender bliss for calming sensitive skin.',
      skinTypes: ["sensitive", "normal", "dry"],
      concerns: ["eczema", "redness", "none"],
      scents: ["floral"],
      categories: ["soap"],
      boost: 2
    },

    {
      handle: 'oatmeal-milk-honey-soap-bar',
      reason: 'Colloidal oatmeal and goat milk make this our gentlest bar for reactive and eczema-prone skin.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "dryness", "redness"],
      scents: ["sweet", "warm"],
      categories: ["soap"],
      boost: 3
    },

    {
      handle: 'avocado-butter-soap-bar',
      reason: 'Unscented and ultra-pure, this bar is moisture in its simplest, kindest form.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "dryness", "redness"],
      scents: ["unscented", "light"],
      categories: ["soap"],
      boost: 1
    },

    {
      handle: 'rosemary-sage-soap-bar',
      reason: 'Herbaceous and invigorating, perfect for starting your day with clarity.',
      skinTypes: ["normal", "combination", "oily"],
      concerns: ["none", "breakouts"],
      scents: ["herbal"],
      categories: ["soap"],
      boost: 1
    },

    {
      handle: 'mountain-sage-milk-and-honey-soap-bar',
      reason: 'Mountain sage meets goat milk for an uplifting bar that won\'t dry you out.',
      skinTypes: ["sensitive", "dry", "combination"],
      concerns: ["dryness", "none"],
      scents: ["herbal", "sweet"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'lithia-park-soap-bar',
      reason: 'Feel grounded with this woodsy, forest-inspired bar that\'s pure Southern Oregon magic.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["woodsy"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'chocolate-lavender-soap-bar',
      reason: 'Cocoa butter and lavender blend to soothe while the rich base moisturizes deeply.',
      skinTypes: ["combination", "normal", "dry"],
      concerns: ["dryness", "none"],
      scents: ["sweet", "floral"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'mt-ashland-soap-bar',
      reason: 'Warm and woodsy, this mountain morning bar awakens the senses gently.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["woodsy"],
      categories: ["soap"],
      boost: 1
    },

    {
      handle: 'lemon-verbena-soap-bar',
      reason: 'Bright and clean, this citrus bar uplifts without irritating your skin.',
      skinTypes: ["normal", "oily", "combination"],
      concerns: ["none", "breakouts"],
      scents: ["citrus", "fresh"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'eucalyptus-tea-tree-soap-bar',
      reason: 'Antimicrobial eucalyptus and tea tree team up to keep breakout-prone skin clear.',
      skinTypes: ["oily", "combination", "normal"],
      concerns: ["breakouts", "none"],
      scents: ["herbal", "fresh"],
      categories: ["soap"],
      boost: 1
    },

    {
      handle: 'blackberry-beeswax-soap-bar',
      reason: 'Beeswax and blackberry create a nourishing bar that feels luxuriously rich.',
      skinTypes: ["normal", "dry"],
      concerns: ["dryness", "none"],
      scents: ["sweet"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'camping-soap-bar',
      reason: 'Multi-use hemp bar with natural bug-repellent properties—your adventure essential.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["herbal"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'chocolate-chip-soap-bar',
      reason: 'Fun chocolate cocoa butter bar that makes bath time feel indulgent and playful.',
      skinTypes: ["normal", "dry"],
      concerns: ["dryness", "none"],
      scents: ["sweet"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'chocolate-strawberry-soap-bar',
      reason: 'Sweet strawberry meets rich chocolate for a dessert-inspired cleanse.',
      skinTypes: ["normal", "dry"],
      concerns: ["dryness", "none"],
      scents: ["sweet"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'chocolate-velvet-rose-soap-bar',
      reason: 'Romance in a bar—cocoa and rose together create pure luxury.',
      skinTypes: ["combination", "normal", "dry"],
      concerns: ["dryness", "none"],
      scents: ["sweet", "floral"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'cinnamon-soap-bar',
      reason: 'Warming cinnamon brings comfort and spice to your daily cleanse.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["sweet", "warm"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'cocoa-butter-cream-soap-bar',
      reason: 'Rich cocoa butter melts into your skin, leaving it velvety and nourished.',
      skinTypes: ["dry", "normal"],
      concerns: ["dryness", "none"],
      scents: ["sweet"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'coconut-lemongrass-lime-soap-bar',
      reason: 'Tropical coconut meets zesty citrus for a refreshing, energizing cleanse.',
      skinTypes: ["normal", "combination", "oily"],
      concerns: ["none"],
      scents: ["citrus", "sweet", "fresh"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'lingonberry-seed-soap-bar',
      reason: 'Exfoliating lingonberry seeds polish skin while the bar moisturizes gently.',
      skinTypes: ["normal", "combination"],
      concerns: ["none", "dryness"],
      scents: ["sweet", "fruity", "fresh"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'cucumber-melon-clay-soap-bar',
      reason: 'Refreshing cucumber melon with clarifying clay—perfect for breakout-prone skin.',
      skinTypes: ["combination", "oily", "normal"],
      concerns: ["breakouts", "none"],
      scents: ["fruity", "fresh"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'fresh-mint-soap-bar',
      reason: 'Fresh peppermint tingles pleasantly while cleansing normal to oily skin.',
      skinTypes: ["normal", "oily", "combination"],
      concerns: ["none"],
      scents: ["herbal", "fresh"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'ginger-goat-milk-soap-bar',
      reason: 'Warming ginger and soothing goat milk make this bar both comforting and nourishing.',
      skinTypes: ["sensitive", "dry", "normal"],
      concerns: ["dryness", "none"],
      scents: ["sweet"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'ginger-peach-loofah-soap-bar',
      reason: 'Exfoliating loofah with ginger and peach gives you gentle polish and warmth.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["sweet", "fruity", "fresh"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'gardenia-rose-clay-soap-bar',
      reason: 'Floral gardenia and rose clay cleanse while maintaining your skin\'s natural balance.',
      skinTypes: ["normal", "combination", "dry"],
      concerns: ["none", "dryness"],
      scents: ["floral", "herbal", "fresh"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'hemp-soap-bar-with-hemp-seed-oil',
      reason: 'Hemp seed oil calms inflammation—your best friend for eczema and sensitive skin.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "dryness"],
      scents: ["herbal"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'honey-calendula-soap-bar',
      reason: 'Honey and calendula together soothe and heal reactive, eczema-prone skin beautifully.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "dryness", "redness"],
      scents: ["sweet", "light", "unscented"],
      categories: ["soap"],
      boost: 1
    },

    {
      handle: 'lemongrass-lime-soap-bar',
      reason: 'Bright lemongrass and lime lift your mood while cleansing fresh and clean.',
      skinTypes: ["normal", "oily", "combination"],
      concerns: ["none"],
      scents: ["citrus", "herbal", "fresh"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'oregon-coast-soap',
      reason: 'Sea salt exfoliates gently while evoking the Pacific Northwest\'s wild, invigorating spirit.',
      skinTypes: ["normal", "combination", "oily"],
      concerns: ["none"],
      scents: ["herbal", "fresh", "earthy"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'butterscotch-brew-soap-bar',
      reason: 'Oatmeal stout beer soap with hops—a cozy, unique bar you\'ll crave.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["sweet", "fresh"],
      categories: ["soap"],
      boost: 1
    },

    {
      handle: 'mango-tea-soap-bar',
      reason: 'Tropical mango pairs with tea for a bright, uplifting cleanse.',
      skinTypes: ["normal", "dry"],
      concerns: ["dryness", "none"],
      scents: ["fruity", "herbal"],
      categories: ["soap"],
      boost: 0
    },

    {
      handle: 'autumn-magic-soap-bar',
      reason: 'Seasonal autumn spices create a warm, cozy bar perfect for fall self-care.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["sweet", "warm"],
      categories: ["soap"],
      boost: 0
    },

    // ===== BODY SCRUBS (7 items) =====

    {
      handle: 'acne-fighting-tea-tree-mint-foaming-sugar-scrub',
      reason: 'This 3-in-1 scrub, cleanser, and moisturizer targets breakouts head-on with proven ingredients.',
      skinTypes: ["oily", "combination"],
      concerns: ["breakouts", "redness"],
      scents: ["herbal", "fresh"],
      categories: ["scrub"],
      boost: 2
    },

    {
      handle: 'balancing-herbal-lavender-sugar-scrub',
      reason: 'Gentle lavender exfoliation that soothes and balances reactive skin without harshness.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "redness", "dryness"],
      scents: ["floral"],
      categories: ["scrub"],
      boost: 1
    },

    {
      handle: 'purifying-eucalyptus-mint-foaming-sugar-scrub',
      reason: 'Deep cleanse breakout-prone skin with invigorating eucalyptus and purifying mint.',
      skinTypes: ["oily", "combination", "normal"],
      concerns: ["breakouts", "none"],
      scents: ["herbal", "fresh"],
      categories: ["scrub"],
      boost: 0
    },

    {
      handle: 'uplifting-mango-tea-foaming-sugar-scrub',
      reason: 'Brighten dull, mature skin with tropical mango and tea\'s gentle exfoliating power.',
      skinTypes: ["normal", "dry"],
      concerns: ["dryness", "aging", "none"],
      scents: ["fruity", "fresh", "herbal"],
      categories: ["scrub"],
      boost: 0
    },

    {
      handle: 'soothing-oatmeal-milk-honey-foaming-sugar-scrub',
      reason: 'The gentlest scrub available—perfect for eczema and sensitive skin that still needs gentle exfoliation.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "dryness", "redness"],
      scents: ["sweet", "warm"],
      categories: ["scrub"],
      boost: 1
    },

    {
      handle: 'energizing-peppermint-foaming-sugar-scrub',
      reason: 'Energizing peppermint awakens and refreshes while sugar gently buffs away dead skin.',
      skinTypes: ["normal", "oily", "combination"],
      concerns: ["none"],
      scents: ["herbal", "fresh"],
      categories: ["scrub"],
      boost: 0
    },

    {
      handle: 'lingonberry-lavender-foaming-sugar-scrub',
      reason: 'Lingonberry and lavender combine for a scrub that exfoliates and comforts simultaneously.',
      skinTypes: ["normal", "dry", "sensitive"],
      concerns: ["dryness", "none"],
      scents: ["floral", "fruity", "fresh"],
      categories: ["scrub"],
      boost: 0
    },

    // ===== LOTIONS, CREAMS, SALVES & OILS (23 items) =====

    {
      handle: 'herbal-lavender-jojoba-avocado-body-lotion',
      reason: 'Calming lavender and deep jojoba-avocado moisture soothe eczema and sensitive skin.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "dryness", "redness"],
      scents: ["floral"],
      categories: ["lotion"],
      boost: 2
    },

    {
      handle: 'eucalyptus-mint-body-lotion',
      reason: 'Cooling eucalyptus mint lotion refreshes without leaving oily residue on your skin.',
      skinTypes: ["normal", "oily", "combination"],
      concerns: ["none"],
      scents: ["herbal", "fresh"],
      categories: ["lotion"],
      boost: 0
    },

    {
      handle: 'lemon-verbena-jojoba-avocado-body-lotion',
      reason: 'Bright citrus meets lightweight moisture—the perfect lotion for those who want hydration without heaviness.',
      skinTypes: ["normal", "combination"],
      concerns: ["none", "dryness"],
      scents: ["citrus", "fresh"],
      categories: ["lotion"],
      boost: 0
    },

    {
      handle: 'mango-tea-jojoba-avocado-body-lotion',
      reason: 'Tropical mango and nourishing oils hydrate and brighten mature, dry skin.',
      skinTypes: ["dry", "normal"],
      concerns: ["dryness", "aging"],
      scents: ["fruity", "herbal", "fresh"],
      categories: ["lotion"],
      boost: 0
    },

    {
      handle: 'oatmeal-almond-milk-honey-jojoba-avocado-body-lotion',
      reason: 'Oatmeal\'s soothing power combined with oils creates a healing lotion for eczema-prone skin.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "dryness", "redness"],
      scents: ["sweet", "warm"],
      categories: ["lotion"],
      boost: 1
    },

    {
      handle: 'vanilla-chai-tea-jojoba-avocado-body-lotion',
      reason: 'Warm vanilla chai spices and nourishing oils create cozy comfort in a lotion.',
      skinTypes: ["normal", "dry"],
      concerns: ["dryness", "none"],
      scents: ["sweet", "warm"],
      categories: ["lotion"],
      boost: 0
    },

    {
      handle: 'unscented-jojoba-avocado-body-lotion',
      reason: 'Fragrance-free and pure—this lotion is your best friend if scent sensitivity is a concern.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "dryness", "redness"],
      scents: ["unscented", "light"],
      categories: ["lotion"],
      boost: 1
    },

    {
      handle: 'coconut-vanilla-hand-body-cream',
      reason: 'Rich coconut and shea butter create a creamy dream for dry, sensitive skin.',
      skinTypes: ["dry", "sensitive"],
      concerns: ["dryness", "eczema"],
      scents: ["sweet", "warm"],
      categories: ["lotion"],
      boost: 1
    },

    {
      handle: 'chocolate-strawberry-organic-cocoa-butter',
      reason: 'Velvety cocoa butter melts into hands and body, leaving silky, nourished skin.',
      skinTypes: ["dry", "normal"],
      concerns: ["dryness", "none"],
      scents: ["sweet"],
      categories: ["lotion"],
      boost: 0
    },

    {
      handle: 'ginger-milk-body-butter',
      reason: 'Warming ginger and creamy milk butter provide cozy comfort for dry skin.',
      skinTypes: ["dry", "normal"],
      concerns: ["dryness"],
      scents: ["sweet"],
      categories: ["lotion"],
      boost: 0
    },

    {
      handle: 'peppermint-body-butter',
      reason: 'Cooling peppermint body butter refreshes and softens without heaviness.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["herbal"],
      categories: ["lotion"],
      boost: 0
    },

    {
      handle: 'pink-grapefruit-body-butter',
      reason: 'Bright grapefruit uplifts while creamy butter nourishes your entire body.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["citrus"],
      categories: ["lotion"],
      boost: 0
    },

    {
      handle: 'jojoba-avocado-lotion-soap-bar-set',
      reason: 'Lotion and soap bar set—the perfect pairing for complete skin care.',
      skinTypes: ["sensitive", "dry", "normal"],
      concerns: ["dryness", "none"],
      scents: ["floral", "herbal", "citrus", "woodsy", "sweet", "fruity", "light", "unscented", "warm", "earthy"],
      categories: ["gift", "lotion"],
      boost: 0
    },

    {
      handle: 'lavender-jojoba-lotion-soap-gift-set',
      reason: 'Calming lavender lotion and soap—a gift that says "I care about your skin."',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "dryness"],
      scents: ["floral"],
      categories: ["gift", "lotion"],
      boost: 0
    },

    {
      handle: 'skin-food-remedy-salve',
      reason: 'Our original healing salve—beeswax, herbs, and oils for skin that needs serious recovery.',
      skinTypes: ["sensitive", "dry", "normal", "combination"],
      concerns: ["eczema", "dryness", "healing", "none"],
      scents: ["herbal"],
      categories: ["lotion"],
      boost: 2
    },

    {
      handle: 'skin-food-remedy-sandalwood-citrus',
      reason: 'Healing salve with a warm sandalwood-citrus scent—pregnancy-safe and deeply nourishing.',
      skinTypes: ["sensitive", "dry", "normal", "combination"],
      concerns: ["eczema", "dryness", "healing", "none"],
      scents: ["woodsy", "citrus"],
      categories: ["lotion", "baby"],
      boost: 2
    },

    {
      handle: 'chamomile-calendula-skin-food-remedy',
      reason: 'Chamomile and calendula calm inflammation and promote healing for the most sensitive skin.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "dryness", "healing", "redness"],
      scents: ["herbal", "floral", "light"],
      categories: ["lotion", "baby"],
      boost: 2
    },

    {
      handle: 'therapeutic-body-oil-serum-love-friendship',
      reason: 'Romantic lavender and rose body oil serum—perfect for massage and self-care rituals.',
      skinTypes: ["sensitive", "dry", "normal"],
      concerns: ["dryness", "none"],
      scents: ["floral"],
      categories: ["lotion"],
      boost: 1
    },

    {
      handle: 'therapeutic-body-oil-serum-meditative-relaxing',
      reason: 'Cedarwood, lavender, and sandalwood body oil—deep relaxation in every drop.',
      skinTypes: ["sensitive", "dry", "normal"],
      concerns: ["dryness", "none"],
      scents: ["woodsy", "floral"],
      categories: ["lotion"],
      boost: 1
    },

    {
      handle: 'therapeutic-body-oil-serum-sore-muscle-sport',
      reason: 'Eucalyptus, peppermint, and rosemary body oil—recovery support for sore muscles.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["fresh", "herbal"],
      categories: ["lotion"],
      boost: 1
    },

    {
      handle: 'therapeutic-body-oil-serum-uplifting-stress-relief',
      reason: 'Bright citrus and herbal blend body oil—uplift your mood and melt away stress.',
      skinTypes: ["normal", "combination", "sensitive"],
      concerns: ["none"],
      scents: ["citrus", "herbal"],
      categories: ["lotion"],
      boost: 1
    },

    {
      handle: 'therapeutic-body-oil-serum-wellness-immune-boost',
      reason: 'Eucalyptus, tea tree, and fir needle body oil—support your immune system naturally.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["fresh", "herbal"],
      categories: ["lotion"],
      boost: 1
    },

    {
      handle: 'therapeutic-body-oil-serum-warming-tension-relief',
      reason: 'Warming cinnamon and black pepper body oil—tension melts with every application.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["warm", "fresh"],
      categories: ["lotion"],
      boost: 1
    },

    // ===== BATH PRODUCTS (26 items) =====

    {
      handle: 'relaxing-lavender-foaming-tub-truffle',
      reason: 'Lavender bath soak that transforms your tub into a spa for relaxation and stress relief.',
      skinTypes: ["sensitive", "normal", "dry"],
      concerns: ["none", "redness"],
      scents: ["floral"],
      categories: ["bath"],
      boost: 1
    },

    {
      handle: 'cozy-oatmeal-milk-honey-foaming-tub-truffle',
      reason: 'Warm oatmeal comfort in a truffle—the ultimate soothing soak for eczema-prone skin.',
      skinTypes: ["sensitive", "dry"],
      concerns: ["eczema", "dryness"],
      scents: ["sweet", "warm"],
      categories: ["bath"],
      boost: 1
    },

    {
      handle: 'stress-relief-foaming-tub-truffle',
      reason: 'Let stress melt away with this carefully blended herbal bath truffle.',
      skinTypes: ["normal", "sensitive", "combination"],
      concerns: ["none"],
      scents: ["herbal", "fresh"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'vanilla-bean-foaming-tub-truffle',
      reason: 'Warm vanilla comfort surrounds you in a luxurious, nourishing soak.',
      skinTypes: ["normal", "dry"],
      concerns: ["none", "dryness"],
      scents: ["sweet", "warm"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'mango-tea-foaming-tub-truffle',
      reason: 'Tropical mango tea creates an uplifting, brightening bath experience.',
      skinTypes: ["normal", "dry"],
      concerns: ["none"],
      scents: ["fruity", "herbal", "fresh"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'lemon-verbena-foaming-tub-truffle',
      reason: 'Bright lemon verbena energizes and cleanses with every soak.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["citrus"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'cheerful-clementine-foaming-tub-truffle',
      reason: 'Uplifting clementine brings sunshine and joy to your bath routine.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["citrus", "fruity"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'romantic-rose-foaming-tub-truffle',
      reason: 'Romantic rose petals and fragrance create a dreamy, indulgent soak.',
      skinTypes: ["normal", "dry"],
      concerns: ["none"],
      scents: ["floral"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'chocolate-milk-foaming-tub-truffle',
      reason: 'Indulgent chocolate milk bath—because sometimes self-care tastes good too.',
      skinTypes: ["normal", "dry"],
      concerns: ["none", "dryness"],
      scents: ["sweet", "warm"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'cucumber-melon-clay-foaming-tub-truffle',
      reason: 'Refreshing cucumber melon with purifying clay—a spa day in your tub.',
      skinTypes: ["combination", "oily", "normal"],
      concerns: ["none"],
      scents: ["fruity"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'white-gardenia-foaming-tub-truffle',
      reason: 'Delicate white gardenia creates a soft, floral bath experience.',
      skinTypes: ["normal", "dry"],
      concerns: ["none"],
      scents: ["floral"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'oregon-forest-tub-truffle',
      reason: 'Woodsy forest scents transport you to the heart of Southern Oregon beauty.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["woodsy"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'black-raspberry-bliss-tub-truffle',
      reason: 'Black raspberry bliss surrounds you in berry sweetness and luxury.',
      skinTypes: ["normal"],
      concerns: ["none"],
      scents: ["sweet"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'pina-colada-tub-truffle',
      reason: 'Tropical piña colada vibes—escape to paradise without leaving home.',
      skinTypes: ["normal"],
      concerns: ["none"],
      scents: ["sweet", "citrus"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'hawaiian-garden-lava-salt-tub-truffle',
      reason: 'Hawaiian garden flowers with lava salt create an exotic, mineral-rich soak.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["floral"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'hot-chocolate-tub-truffle',
      reason: 'Cozy hot chocolate transforms bath time into a warm, comforting ritual.',
      skinTypes: ["normal", "dry"],
      concerns: ["none"],
      scents: ["sweet", "warm"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'lemongrass-lime-tub-truffle',
      reason: 'Bright lemongrass and lime energize and invigorate with every splash.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["citrus", "herbal"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'pinot-noir-rose-clay-tub-truffle',
      reason: 'Wine-inspired rose clay soak—luxe bath time that feels sophisticated and pampering.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["floral", "fruity"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'chocolate-velvet-rose-foaming-tub-cake',
      reason: 'Romantic chocolate rose—a decadent bath cake that feels like pure indulgence.',
      skinTypes: ["normal", "dry"],
      concerns: ["none", "dryness"],
      scents: ["sweet", "floral"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'pink-grapefruit-and-mint-foaming-tub-cake',
      reason: 'Energizing grapefruit mint cake—perfect for starting your day with an invigorating soak.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["citrus", "fresh"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'lemon-cream-calendula-foaming-tub-cake',
      reason: 'Soothing calendula and bright lemon create a gentle, healing bath cake.',
      skinTypes: ["sensitive", "normal", "dry"],
      concerns: ["redness", "none"],
      scents: ["citrus", "sweet"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'oregon-lavender-vanilla-bean-foaming-tub-cake',
      reason: 'Lavender and vanilla in a dreamy bath cake—pure Oregon comfort.',
      skinTypes: ["sensitive", "normal", "dry"],
      concerns: ["none"],
      scents: ["floral", "sweet"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'key-lime-poppyseed-tub-cake',
      reason: 'Bright key lime with playful poppy seeds creates a joyful, refreshing soak.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["citrus", "sweet"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'happy-birthday-cupcake-foaming-tub-cake',
      reason: 'Make bathtime a celebration with this fun, festive birthday cupcake cake.',
      skinTypes: ["normal"],
      concerns: ["none"],
      scents: ["sweet"],
      categories: ["bath", "gift"],
      boost: 0
    },

    {
      handle: 'orange-cream-cornflower-tub-cake',
      reason: 'Orange cream with cornflower creates a sophisticated, floral-citrus experience.',
      skinTypes: ["normal", "dry"],
      concerns: ["none"],
      scents: ["citrus", "sweet"],
      categories: ["bath"],
      boost: 0
    },

    {
      handle: 'autumn-magic-pumpkin-spice-tub-cake',
      reason: 'Seasonal pumpkin spice magic brings cozy autumn vibes to your bath.',
      skinTypes: ["normal"],
      concerns: ["none"],
      scents: ["sweet", "warm"],
      categories: ["bath"],
      boost: 0
    },

    // ===== BABY & MOM (5 items) =====

    {
      handle: 'baby-body-lotion',
      reason: 'Gentle enough for baby, effective enough for everyone—lavender and eucalyptus soothe and protect.',
      skinTypes: ["sensitive", "normal"],
      concerns: ["eczema", "dryness", "none"],
      scents: ["citrus", "herbal", "light"],
      categories: ["baby"],
      boost: 2
    },

    {
      handle: 'baby-bum-cream',
      reason: 'Calendula and chamomile create a protective barrier for delicate baby skin.',
      skinTypes: ["sensitive"],
      concerns: ["eczema", "redness", "healing"],
      scents: ["herbal", "light"],
      categories: ["baby"],
      boost: 2
    },

    {
      handle: 'mothers-salve',
      reason: 'Made for nursing moms—heals and protects with all-natural ingredients.',
      skinTypes: ["sensitive", "normal"],
      concerns: ["healing", "dryness"],
      scents: ["herbal", "light"],
      categories: ["baby"],
      boost: 2
    },

    {
      handle: 'baby-shower-gift-set',
      reason: 'Everything a new parent needs in one beautiful set—gentle, natural, and thoughtful.',
      skinTypes: ["sensitive", "normal"],
      concerns: ["none", "eczema"],
      scents: ["light", "citrus", "herbal"],
      categories: ["baby", "gift"],
      boost: 1
    },

    {
      handle: 'baby-mother-shower-gift-set',
      reason: 'A gift for both mom and baby—natural care products for the whole new family.',
      skinTypes: ["sensitive", "normal"],
      concerns: ["none", "eczema", "healing"],
      scents: ["light", "citrus", "herbal"],
      categories: ["baby", "gift"],
      boost: 1
    },

    // ===== LIP CARE (13 items) =====

    {
      handle: 'manuka-mint-lip-balm',
      reason: 'Manuka honey and mint work together—healing for cold sores and deeply moisturizing.',
      skinTypes: ["sensitive", "dry", "normal"],
      concerns: ["dryness", "healing"],
      scents: ["fresh", "herbal"],
      categories: ["lip"],
      boost: 1
    },

    {
      handle: 'orange-cream-lip-balm',
      reason: 'Bright orange cream flavor with cocoa butter—a sweet citrus treat for your lips.',
      skinTypes: ["sensitive", "dry", "normal", "oily", "combination", "mature"],
      concerns: ["dryness", "none"],
      scents: ["citrus", "sweet"],
      categories: ["lip"],
      boost: 0
    },

    {
      handle: 'coconut-cocoa-butter-lip-balm',
      reason: 'Rich cocoa butter and coconut oil for deeply nourished, tropical-soft lips.',
      skinTypes: ["sensitive", "dry", "normal", "oily", "combination", "mature"],
      concerns: ["dryness", "none"],
      scents: ["sweet"],
      categories: ["lip"],
      boost: 0
    },

    {
      handle: 'vanilla-cream-lip-balm',
      reason: 'Classic vanilla cream—smooth, sweet, and endlessly wearable.',
      skinTypes: ["sensitive", "dry", "normal", "oily", "combination", "mature"],
      concerns: ["dryness", "none"],
      scents: ["sweet"],
      categories: ["lip"],
      boost: 0
    },

    {
      handle: 'sun-lip-therapy-zinc-oxide-lip-balm',
      reason: 'Zinc oxide lip protection—unscented, mineral-based sun care for your lips.',
      skinTypes: ["sensitive", "dry", "normal", "oily", "combination", "mature"],
      concerns: ["dryness", "none"],
      scents: ["unscented", "light"],
      categories: ["lip"],
      boost: 1
    },

    {
      handle: 'golden-milk-lip-balm',
      reason: 'Turmeric, cinnamon, and ginger—warm golden milk goodness for your lips.',
      skinTypes: ["sensitive", "dry", "normal", "oily", "combination", "mature"],
      concerns: ["dryness", "none"],
      scents: ["warm"],
      categories: ["lip"],
      boost: 0
    },

    {
      handle: 'strawberry-lip-balm',
      reason: 'Sweet strawberry lip balm—fruity, fun, and moisturizing.',
      skinTypes: ["sensitive", "dry", "normal", "oily", "combination", "mature"],
      concerns: ["dryness", "none"],
      scents: ["fruity", "sweet"],
      categories: ["lip"],
      boost: 0
    },

    {
      handle: 'lip-oil-serum-sheer-sunshine',
      reason: 'Sea buckthorn lip oil serum—nourishing, brightening, and a step above basic balm.',
      skinTypes: ["sensitive", "dry", "normal", "oily", "combination", "mature"],
      concerns: ["dryness", "aging", "none"],
      scents: ["light", "fruity"],
      categories: ["lip"],
      boost: 2
    },

    {
      handle: 'shimmer-stick-blessed-blush',
      reason: 'Frankincense-infused shimmer—natural glow with skin-loving ingredients.',
      skinTypes: ["sensitive", "dry", "normal", "oily", "combination", "mature"],
      concerns: ["none", "dryness"],
      scents: ["woodsy", "herbal", "earthy"],
      categories: ["lip"],
      boost: 1
    },

    {
      handle: 'shimmer-stick-calm-bronze',
      reason: 'Sweet orange shimmer stick—warm bronze glow with a calming citrus scent.',
      skinTypes: ["sensitive", "dry", "normal", "oily", "combination", "mature"],
      concerns: ["none"],
      scents: ["citrus"],
      categories: ["lip"],
      boost: 1
    },

    {
      handle: 'shimmer-stick-blackberry-vanilla',
      reason: 'Blackberry vanilla shimmer—fruity sweetness with a natural, buildable glow.',
      skinTypes: ["sensitive", "dry", "normal", "oily", "combination", "mature"],
      concerns: ["none"],
      scents: ["sweet"],
      categories: ["lip"],
      boost: 1
    },

    {
      handle: 'ruby-rose-shimmer-stick',
      reason: 'Rose and vanilla shimmer—romantic, floral, and absolutely gorgeous.',
      skinTypes: ["sensitive", "dry", "normal", "oily", "combination", "mature"],
      concerns: ["none"],
      scents: ["floral"],
      categories: ["lip"],
      boost: 1
    },

    {
      handle: 'peaceful-pink-shimmer-stick',
      reason: 'Soft pink shimmer stick—subtle, gentle, and perfect for everyday glow.',
      skinTypes: ["sensitive", "dry", "normal", "oily", "combination", "mature"],
      concerns: ["none"],
      scents: ["floral", "herbal"],
      categories: ["lip"],
      boost: 1
    },

    // ===== MEN'S (10 items) =====

    {
      handle: 'tobacco-bay-leaf-aftershave-lotion',
      reason: 'Classic tobacco and bay leaf aftershave—a refined finish that soothes sensitive post-shave skin.',
      skinTypes: ["sensitive", "normal", "combination"],
      concerns: ["redness", "none"],
      scents: ["woodsy", "herbal"],
      categories: ["mens"],
      boost: 1
    },

    {
      handle: 'lemon-sage-aftershave-lotion',
      reason: 'Fresh lemon sage aftershave provides a clean, herbaceous finish without irritation.',
      skinTypes: ["normal", "combination", "oily"],
      concerns: ["none"],
      scents: ["herbal", "citrus"],
      categories: ["mens"],
      boost: 0
    },

    {
      handle: 'sandalwood-vanilla-aftershave-lotion',
      reason: 'Warm sandalwood vanilla aftershave—luxurious and calming for sensitive skin.',
      skinTypes: ["normal", "dry", "sensitive"],
      concerns: ["none", "dryness"],
      scents: ["woodsy", "sweet", "warm"],
      categories: ["mens"],
      boost: 0
    },

    {
      handle: 'tobacco-vanilla-aftershave-lotion',
      reason: 'Tobacco vanilla aftershave—classic comfort with a sweet edge.',
      skinTypes: ["normal", "sensitive", "combination"],
      concerns: ["none"],
      scents: ["woodsy", "sweet", "warm"],
      categories: ["mens"],
      boost: 0
    },

    {
      handle: 'sage-cedar-aftershave-beard-conditioner',
      reason: 'Sage and cedar aftershave doubles as beard conditioner—two grooming needs in one.',
      skinTypes: ["normal", "combination"],
      concerns: ["none"],
      scents: ["woodsy", "herbal"],
      categories: ["mens"],
      boost: 0
    },

    {
      handle: 'beard-oil-shave-protector-tobacco-and-bay-leaf',
      reason: 'Tobacco bay leaf beard oil protects before shaving and conditions after—a gentleman\'s essential.',
      skinTypes: ["normal", "sensitive"],
      concerns: ["none"],
      scents: ["woodsy", "warm", "herbal"],
      categories: ["mens"],
      boost: 0
    },

    {
      handle: 'sandalwood-vanilla-pre-shave-protector-and-conditioning-beard-oil',
      reason: 'Warm sandalwood vanilla beard elixir prepares skin and softens whiskers naturally.',
      skinTypes: ["normal", "sensitive"],
      concerns: ["none"],
      scents: ["woodsy", "sweet", "warm"],
      categories: ["mens"],
      boost: 0
    },

    {
      handle: 'tobacco-and-bay-leaf-organic-natural-shaving-cream-soap-beard-shampoo',
      reason: 'All-in-one shaving cream, soap, and beard shampoo—the complete grooming ritual.',
      skinTypes: ["normal", "sensitive", "combination"],
      concerns: ["none"],
      scents: ["woodsy", "herbal", "warm"],
      categories: ["mens"],
      boost: 1
    },

    {
      handle: 'sandalwood-vanilla-organic-shaving-cream-soap',
      reason: 'Sandalwood vanilla shaving cream creates a luxurious lather that protects sensitive skin.',
      skinTypes: ["normal", "sensitive"],
      concerns: ["none"],
      scents: ["woodsy", "sweet", "warm"],
      categories: ["mens"],
      boost: 0
    },

    {
      handle: 'complete-natural-shaving-set',
      reason: 'Complete grooming set for the natural-minded gentleman—thoughtful and practical.',
      skinTypes: ["normal", "sensitive"],
      concerns: ["none"],
      scents: ["woodsy", "herbal", "warm", "sweet"],
      categories: ["gift", "mens"],
      boost: 1
    },

    // ===== GIFT SETS (3 items) =====

    {
      handle: 'all-soaps-sample-pack',
      reason: 'Complete soap sample pack—discover your favorite scent and skin match.',
      skinTypes: ["normal", "combination", "dry", "sensitive", "oily"],
      concerns: ["none"],
      scents: ["floral", "herbal", "citrus", "woodsy", "sweet", "fruity", "light", "unscented", "warm", "earthy"],
      categories: ["gift"],
      boost: 0
    },

    {
      handle: 'mini-soap-sampler',
      reason: 'Five handcrafted mini bars—a perfect gift for soap lovers everywhere.',
      skinTypes: ["normal", "combination", "dry", "sensitive"],
      concerns: ["none"],
      scents: ["floral", "herbal", "citrus", "woodsy", "sweet"],
      categories: ["gift"],
      boost: 0
    },

    {
      handle: '3-soap-bars-boxed-set',
      reason: 'Three beautiful bars in a gift box—simplicity and luxury combined.',
      skinTypes: ["normal", "combination", "dry", "sensitive"],
      concerns: ["none"],
      scents: ["floral", "herbal", "citrus", "woodsy", "sweet", "fruity", "light", "unscented", "warm", "earthy"],
      categories: ["gift"],
      boost: 0
    }
  ]
};